import Vue from 'vue'
import Vuetify from 'vuetify/lib/framework'
import pt from 'vuetify/es5/locale/pt'

Vue.use(Vuetify)

const vuetify = new Vuetify({
  theme: {
    options: {
      customProperties: true,
    },
    themes: {
      light: {
        primary: '#006bf2',
      },
    },
  },
  lang: {
    locales: { pt },
    current: 'pt',
  },
})

export const setPrimaryColor = color => {
  if (vuetify.framework && vuetify.framework.theme && vuetify.framework.theme.themes) {
    vuetify.framework.theme.themes.light.primary = color || '#006bf2'
  }
}

export default vuetify
